import * as React from 'react';
import { MenuItem as MenuItemType } from 'moduleBase/types/Menu';
import { MenuItemImage } from 'moduleBase/components/menu/MenuItemImage';
import { MenuItemBadge } from 'moduleBase/components/menu/MenuItemBadge';
import { When } from 'react-if';
import { Badge } from 'ui/badge/Badge';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import { FC } from 'react';

type PropsType = Omit<MenuItemType, 'items' | 'isVisibleDesktop'> & {
  imageWidth?: number;
  imageClassName?: string;
};

const MenuItemContent: FC<PropsType> = ({
  label,
  badge,
  icon,
  image,
  imageWidth = null,
  imageClassName = 'mr-10p',
  notify,
}) => (
  <>
    <MenuItemImage icon={icon} image={image} imageWidth={imageWidth} imageClassName={imageClassName} />
    {label}
    <When condition={notify}>
      <Badge variant={Variant.warning} pill additionalClassName="text-white ml-1">
        {notify}
      </Badge>
    </When>
    <MenuItemBadge badge={badge} />
  </>
);

export { MenuItemContent };
